import { render, staticRenderFns } from "./comp-full-screen.vue?vue&type=template&id=7a804dee&scoped=true&lang=pug&"
import script from "./comp-full-screen.vue?vue&type=script&lang=js&"
export * from "./comp-full-screen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a804dee",
  null
  
)

export default component.exports